'use strict';

class AutoSlideShow {
  constructor(callback, delay) {
    this.callback = callback;
    this.enabled = false;
    this.delay = delay;
    this.transitionInterval = null;
  }

  isEnabled() {
    return this.enabled;
  }

  enable() {
    if (this.enabled) {
      return;
    }

    this.enabled = true;
    this.start();
  }

  disable() {
    if (!this.enabled) {
      return;
    }

    this.enabled = false;
    this.stop();
  }

  start() {
    if (this.transitionInterval) {
      return;
    }

    this.transitionInterval = window.setInterval(this.callback, this.delay);
  }

  stop() {
    if (!this.transitionInterval) {
      return;
    }

    window.clearInterval(this.transitionInterval);
    this.transitionInterval = null;
  }
}

module.exports = AutoSlideShow;
